<template>
  <div class="portefeuille-section portefeuille-module portefeuille-housings-module">
    <v-container class="section-content">
      <button class="back-button" @click="goBack">
        <span class="fa fa-arrow-left"></span> {{ $t('common.back') }}
      </button>

      <div class="page-header">
        <div class="header-content">
          <h1 class="page-title">{{ $t('portefeuille.housings') }}</h1>
          <p class="page-subtitle">{{ $t('portefeuille.housings_subtitle') }}</p>
        </div>
      </div>

      <div class="toolbar-section">
        <div class="search-box">
          <span class="fa fa-search search-icon"></span>
          <input
            v-model="searchQuery"
            type="text"
            :placeholder="$t('portefeuille.search_housing')"
            class="search-input"
          />
        </div>
        <button class="add-button" @click="openAddDialog">
          <span class="fa fa-plus"></span> {{ $t('common.add') }}
        </button>
      </div>

      <div v-if="loading" class="empty-state">
        <span class="fa fa-spinner fa-spin empty-icon"></span>
        <p class="empty-text">{{ $t('common.loading') }}</p>
      </div>

      <div v-else-if="filteredHousings.length === 0" class="empty-state">
        <span class="fa fa-home empty-icon"></span>
        <p class="empty-text">{{ $t('portefeuille.no_housings') }}</p>
      </div>

      <div v-else class="table-wrapper">
        <table class="housings-table">
          <thead>
            <tr>
              <th>{{ $t('portefeuille.housing') }}</th>
              <th>{{ $t('portefeuille.housing_address') }}</th>
              <th>{{ $t('portefeuille.housing_rooms') }}</th>
              <th>{{ $t('portefeuille.housing_area') }}</th>
              <th>{{ $t('common.action') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="housing in filteredHousings" :key="housing._id" class="table-row">
              <td class="housing-cell">
                <span class="housing-icon fa fa-home"></span>
                <div class="housing-info">
                  <div class="housing-name">{{ housing.typeBien }}</div>
                  <div class="housing-details">{{ housing.nombrepiece }} pieces · {{ housing.superficie }}m²</div>
                </div>
              </td>
              <td>{{ housing.adresselogement }}</td>
              <td>{{ housing.nombrepiece }}</td>
              <td>{{ housing.superficie }} m²</td>
              <td class="action-cell">
                <div class="action-buttons">
                  <button class="action-btn" @click="editHousing(housing)" title="Modifier">
                    <span class="fa fa-edit"></span>
                  </button>
                  <button class="action-btn" @click.stop="requestDeleteHousing(housing._id)" title="Supprimer">
                    <span class="fa fa-trash"></span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-container>

    <v-dialog v-model="itemDialog" max-width="750" scrollable persistent>
      <v-card elevation="24" class="border-radius portefeuille-modal-accent-blue">
        <v-card-text style="background: #fafafa">
          <div class="wizard-tab-content">
            <div role="tabpanel" class="wizard-tab-container">
              <div class="fields">
                <div class="field-title font-weight-bold">
                  {{ editingItem ? 'Modifier un logement' : 'Ajouter un logement' }}
                </div>

                <!-- TYPE DE BIEN (SELECT) -->
                <div class="row mt-3">
                  <div class="col-sm-12">
                    <label class="field-label font-weight-bold">Type de bien <span style="color: #e74c3c;">*</span></label>
                    <div class="type-buttons">
                      <div class="type-btn">
                        <input type="radio" v-model="formData.typeBien" value="appartement" id="type-apart">
                        <label for="type-apart"><span class="fa fa-building"></span> Appartement</label>
                      </div>
                      <div class="type-btn">
                        <input type="radio" v-model="formData.typeBien" value="maison" id="type-maison">
                        <label for="type-maison"><span class="fa fa-home"></span> Maison (max R+2)</label>
                      </div>
                      <div class="type-btn">
                        <input type="radio" v-model="formData.typeBien" value="immeuble" id="type-immeuble">
                        <label for="type-immeuble"><span class="fa fa-building"></span> Immeuble</label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ADRESSE & SUPERFICIE -->
                <div class="row mt-4">
                  <div class="col-sm-6">
                    <div class="field-group field-default">
                      <label class="field-label">Adresse du logement <span style="color: #e74c3c;">*</span></label>
                      <input v-model="formData.adresselogement" type="text" class="field-input" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="field-group field-default">
                      <label class="field-label">Superficie (m²) <span style="color: #e74c3c;">*</span></label>
                      <input v-model="formData.superficie" type="number" class="field-input" min="4" />
                    </div>
                  </div>
                </div>

                <!-- NOMBRE DE PIECES & ETAGES -->
                <div class="row mt-3">
                  <div class="col-sm-6">
                    <div class="field-group field-default">
                      <label class="field-label">Nombre de pièces <span style="color: #e74c3c;">*</span></label>
                      <v-autocomplete
                        v-model="formData.nombrepiece"
                        :items="roomsOptions"
                        dense
                        outlined
                        clearable
                        placeholder="Sélectionner..."
                        class="field-autocomplete"
                      ></v-autocomplete>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="field-group field-default">
                      <label class="field-label">Nombre d'étages</label>
                      <input v-model="formData.nombreetage" type="number" class="field-input" />
                    </div>
                  </div>
                </div>

                <!-- TYPE DE TOITURE & ENVIRONNEMENT -->
                <div class="row mt-3">
                  <div class="col-sm-6">
                    <div class="field-group field-default">
                      <label class="field-label">Nature de couverture</label>
                      <v-autocomplete
                        v-model="formData.naturecouverture"
                        :items="['Béton', 'Tuile (ardoise)', 'Tôle metal', 'Paille']"
                        dense
                        outlined
                        clearable
                        placeholder="Sélectionner..."
                        class="field-autocomplete"
                      ></v-autocomplete>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="field-group field-default">
                      <label class="field-label">Environnement immédiat</label>
                      <v-autocomplete
                        v-model="formData.environnement_immediat"
                        :items="['Quartier résidentiel', 'Chantiers à proximité', 'Proche Usine/Marche/Station Essence']"
                        dense
                        outlined
                        clearable
                        placeholder="Sélectionner..."
                        class="field-autocomplete"
                      ></v-autocomplete>
                    </div>
                  </div>
                </div>

                <!-- QUALITÉ ASSURÉ -->
                <div class="row mt-3">
                  <div class="col-sm-12">
                    <label class="field-label font-weight-bold">Qualité assuré <span style="color: #e74c3c;">*</span></label>
                    <div class="quality-buttons">
                      <div class="quality-btn">
                        <input type="radio" v-model="formData.qualiteassure" value="locataire" id="qual-locataire">
                        <label for="qual-locataire"><span class="fa fa-key"></span> Locataire</label>
                      </div>
                      <div class="quality-btn">
                        <input type="radio" v-model="formData.qualiteassure" value="proprio_occupant" id="qual-proprio-occ">
                        <label for="qual-proprio-occ"><span class="fa fa-home"></span> Propriétaire occupant</label>
                      </div>
                      <div class="quality-btn">
                        <input type="radio" v-model="formData.qualiteassure" value="proprio_non_occupant" id="qual-proprio-non">
                        <label for="qual-proprio-non"><span class="fa fa-file"></span> Propriétaire non-occupant</label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- MONTANT LOYER (SI LOCATAIRE) -->
                <div v-show="formData.qualiteassure === 'locataire'" class="row mt-3">
                  <div class="col-sm-6">
                    <div class="field-group field-default">
                      <label class="field-label">Montant du loyer (FCFA) <span style="color: #e74c3c;">*</span></label>
                      <input v-model="formData.montaLoyer" type="number" class="field-input" min="50000" @change="calculateValeurBatiment" />
                      <small style="color: #999;">Minimum 50,000 FCFA</small>
                    </div>
                  </div>
                </div>

                <!-- VALEUR DU CONTENU & VALEUR DU BATIMENT -->
                <div class="row mt-3">
                  <div class="col-sm-6">
                    <div class="field-group field-default">
                      <label class="field-label">Valeur du contenu (FCFA)</label>
                      <input v-model="formData.valeurcontenu" type="number" class="field-input" min="2000000" />
                      <small style="color: #999;">Minimum 2,000,000 FCFA</small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="field-group field-default">
                      <label class="field-label">Valeur du bâtiment (FCFA) <span v-if="formData.qualiteassure === 'locataire'" style="color: #999;">(calculée)</span></label>
                      <input v-model="formData.valeurbatiment" type="number" class="field-input" min="2000000" :readonly="formData.qualiteassure === 'locataire'" />
                      <small style="color: #999;">Minimum 2,000,000 FCFA</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button type="button" class="wizard-btn" @click="itemDialog = false">Annuler</button>
              </div>
              <div class="wizard-footer-right">
                <button type="button" class="wizard-btn" @click="saveHousing">Enregistrer</button>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="460" persistent>
      <v-card elevation="24" class="border-radius portefeuille-modal-accent-blue">
        <v-card-text style="background: #fafafa">
          <div class="wizard-tab-content">
            <div role="tabpanel" class="wizard-tab-container">
              <div class="fields text-center">
                <div class="field-title font-weight-bold">Supprimer</div>
                <div class="field-sub-title">{{ $t('common.confirm_delete', 'Êtes-vous sûr ?') }}</div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button type="button" class="wizard-btn" @click="cancelDeleteHousing">Annuler</button>
              </div>
              <div class="wizard-footer-right">
                <button type="button" class="wizard-btn" @click="confirmDeleteHousing">Supprimer</button>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'PortefeuilleHousings',
  data() {
    return {
      searchQuery: '',
      itemDialog: false,
      deleteDialog: false,
      pendingDeleteId: null,
      editingItem: null,
      formData: {
        typeBien: '',
        adresselogement: '',
        nombrepiece: '',
        nombreetage: 0,
        superficie: 0,
        naturecouverture: '',
        environnement_immediat: '',
        valeurcontenu: 0,
        valeurbatiment: 0,
        qualiteassure: '',
        montaLoyer: 0
      }
    }
  },
  computed: {
    ...mapState('housings', ['loading']),
    ...mapGetters('housings', ['listeHousings']),
    filteredHousings() {
      if (!this.searchQuery) return this.listeHousings
      const query = this.searchQuery.toLowerCase()
      return this.listeHousings.filter(housing =>
        String(housing.typeBien || '').toLowerCase().includes(query) ||
        String(housing.adresselogement || '').toLowerCase().includes(query)
      )
    },
    roomsOptions() {
      const options = []
      for (let i = 1; i <= 20; i++) {
        options.push(i)
      }
      return options
    }
  },
  methods: {
    ...mapActions('housings', ['fetchHousings', 'addHousing', 'updateHousing', 'deleteHousing']),

    async loadHousings() {
      try {
        await this.fetchHousings()
      } catch (error) {
        this.$toasted.show(this.$t('common.error_loading', 'Erreur de chargement'), {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 3000
        })
      }
    },

    openAddDialog() {
      this.editingItem = null
      this.formData = {
        typeBien: '',
        adresselogement: '',
        nombrepiece: '',
        nombreetage: 0,
        superficie: 0,
        naturecouverture: '',
        environnement_immediat: '',
        valeurcontenu: 0,
        valeurbatiment: 0,
        qualiteassure: '',
        montaLoyer: 0
      }
      this.itemDialog = true
    },

    editHousing(housing) {
      this.editingItem = housing
      this.formData = {
        typeBien: housing.typeBien || '',
        adresselogement: housing.adresselogement || '',
        nombrepiece: housing.nombrepiece || '',
        nombreetage: housing.nombreetage || 0,
        superficie: housing.superficie || 0,
        naturecouverture: housing.naturecouverture || '',
        environnement_immediat: housing.environnement_immediat || '',
        valeurcontenu: housing.valeurcontenu || 0,
        valeurbatiment: housing.valeurbatiment || 0,
        qualiteassure: housing.qualiteassure || '',
        montaLoyer: housing.montaLoyer || 0
      }
      this.itemDialog = true
    },

    requestDeleteHousing(id) {
      this.pendingDeleteId = id
      this.deleteDialog = true
    },

    cancelDeleteHousing() {
      this.pendingDeleteId = null
      this.deleteDialog = false
    },

    async confirmDeleteHousing() {
      if (!this.pendingDeleteId) return

      try {
        await this.deleteHousing(this.pendingDeleteId)
        this.$toasted.show(this.$t('common.deleted', 'Supprimé avec succès'), {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 3000
        })
      } catch (error) {
        this.$toasted.show(this.$t('common.error_delete', 'Erreur de suppression'), {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 3000
        })
      } finally {
        this.cancelDeleteHousing()
      }
    },

    calculateValeurBatiment() {
      // Calcul automatique de la valeur du bâtiment pour locataires
      // Formule: Valeur bâtiment = Montant loyer × 180
      if (this.formData.qualiteassure === 'locataire' && this.formData.montaLoyer) {
        const loyer = Number(this.formData.montaLoyer)
        if (!isNaN(loyer) && loyer >= 50000) {
          this.formData.valeurbatiment = Math.round(loyer * 180)
        }
      }
    },

    showError(message) {
      // Fermer tous les toasts existants avant d'afficher un nouveau
      this.$toasted.clear()
      this.$toasted.show(message, {
        theme: 'toasted-primary',
        position: 'top-center',
        type: 'error',
        duration: 3000,
        singleton: true
      })
    },

    async saveHousing() {
      // Validation des champs obligatoires
      if (!this.formData.typeBien) {
        this.showError(this.$t('portefeuille.housing_type_required'))
        return
      }
      if (!this.formData.adresselogement) {
        this.showError(this.$t('portefeuille.housing_address_required'))
        return
      }
      if (!this.formData.nombrepiece) {
        this.showError(this.$t('portefeuille.housing_rooms_required'))
        return
      }
      if (!this.formData.superficie || this.formData.superficie < 4) {
        this.showError(this.$t('portefeuille.housing_area_required'))
        return
      }
      if (!this.formData.qualiteassure) {
        this.showError(this.$t('portefeuille.housing_quality_required'))
        return
      }
      if (this.formData.qualiteassure === 'locataire') {
        if (!this.formData.montaLoyer || this.formData.montaLoyer < 50000) {
          this.showError(this.$t('portefeuille.housing_rent_required'))
          return
        }
        // Trigger calculation to ensure value is set
        this.calculateValeurBatiment()
      }

      try {
        if (this.editingItem) {
          await this.updateHousing({ id: this.editingItem._id, housingData: this.formData })
          this.$toasted.clear()
          this.$toasted.show(this.$t('common.updated'), {
            theme: 'toasted-primary',
            position: 'top-center',
            type: 'success',
            duration: 3000,
            singleton: true
          })
        } else {
          await this.addHousing(this.formData)
          this.$toasted.clear()
          this.$toasted.show(this.$t('common.saved'), {
            theme: 'toasted-primary',
            position: 'top-center',
            type: 'success',
            duration: 3000,
            singleton: true
          })
        }
        this.itemDialog = false
      } catch (error) {
        this.showError(this.$t('common.error_saving'))
      }
    },

    goBack() {
      this.$router.push({ name: 'portefeuille' })
    }
  },
  mounted() {
    this.loadHousings()
  }
}
</script>

<style scoped>
.portefeuille-section {
  padding: 2rem;
  padding-top: 100px;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.portefeuille-modal-accent-blue {
  --custom-color-primary: #ffa409;
}

.section-header {
  margin-bottom: 1.5rem;
}

.page-header {
  margin-bottom: 1.5rem;
}

.header-content {
  flex: 1;
}

.page-title {
  font-size: 3.2rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 0.5rem 0;
}

.page-subtitle {
  font-size: 1.4rem;
  color: #666;
  margin: 0;
}

.back-button {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 0.875rem;
  color: #333;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Lato', sans-serif;
  margin-bottom: 1rem;
}

.back-button:hover {
  color: #ffa409;
}

.section-title {
  flex: 1;
  font-size: 1.75rem;
  font-weight: 700;
  color: #000;
  margin: 0;
  font-family: 'Lato', sans-serif;
}

.add-button {
  background: #ffa409;
  border: none;
  color: white;
  padding: 0.8rem 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Lato', sans-serif;
}

.toolbar-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
  gap: 1rem;
}

.search-box {
  flex: 1;
  position: relative;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 0.8rem 1rem;
  display: flex;
  align-items: center;
}

.search-icon {
  color: #999;
  margin-right: 0.8rem;
  font-size: 0.875rem;
}

.search-input {
  border: none;
  outline: none;
  flex: 1;
  font-size: 1rem;
  color: #333;
  background: transparent;
  font-family: 'Lato', sans-serif;
}

.search-input::placeholder {
  color: #999;
}

.add-button:hover {
  background: #ff9500;
  box-shadow: 0 4px 12px rgba(255, 164, 9, 0.3);
}

.section-content {
  /* Vuetify v-container padding par defaut */
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  background: white;
  border-radius: 8px;
}

.empty-icon {
  font-size: 4rem;
  color: #ddd;
  margin-bottom: 1rem;
}

.empty-text {
  font-size: 1.1rem;
  color: #999;
  margin: 0;
}

.table-wrapper {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.housings-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 1.15rem;
}

.housings-table thead {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.housings-table th {
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 1rem;
  letter-spacing: 0.5px;
}

.housings-table th:last-child {
  text-align: right;
}

.table-row {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background-color: #fafafa;
}

.table-row td {
  padding: 1rem;
  color: #333;
}

.housing-cell {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.housing-icon {
  font-size: 1.5rem;
  color: #ffa409;
}

.housing-info {
  display: flex;
  flex-direction: column;
}

.housing-name {
  font-weight: 600;
  color: #1a1a1a;
}

.housing-details {
  font-size: 0.85rem;
  color: #999;
}

.action-cell {
  text-align: right;
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}

.action-btn {
  background: transparent;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #666;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background: #f0f0f0;
  color: #ffa409;
}

.input-field {
  margin-bottom: 1rem;
}

.field-autocomplete {
  margin-top: 0.5rem;
}

.field-autocomplete >>> .v-input__control {
  min-height: 45px;
}

.field-autocomplete >>> .v-text-field__details {
  display: none;
}

.type-buttons,
.quality-buttons {
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
  flex-wrap: wrap;
}

.type-btn,
.quality-btn {
  flex: 1;
  min-width: 140px;
  position: relative;
}

.type-btn input,
.quality-btn input {
  display: none;
}

.type-btn label,
.quality-btn label {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0.8rem;
  border: 2px solid #ddd;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  background-color: white;
  font-weight: 500;
  font-size: 1.05rem;
  gap: 0.5rem;
}

.type-btn label span,
.quality-btn label span {
  font-size: 1.2rem;
}

.type-btn input:checked + label,
.quality-btn input:checked + label {
  border-color: #ffa409;
  background-color: #fff7e8;
  color: #333;
}

.type-btn label:hover,
.quality-btn label:hover {
  border-color: #ffa409;
  box-shadow: 0 2px 8px rgba(255, 164, 9, 0.2);
}

@media only screen and (max-width: 768px) {
  .section-header {
    flex-direction: column;
    align-items: stretch;
  }

  .back-button,
  .add-button {
    justify-content: center;
    font-size: 1rem;
  }

  .section-title {
    font-size: 1.75rem;
  }

  .section-subtitle,
  .page-subtitle {
    font-size: 1rem;
  }

  .portefeuille-section {
    padding: 1rem;
    padding-top: 80px;
  }

  .table-wrapper {
    overflow-x: auto;
  }

  .housings-table {
    font-size: 0.95rem;
  }

  .housings-table th {
    font-size: 0.85rem;
  }

  .housings-table th,
  .housings-table td {
    padding: 0.75rem 0.5rem;
  }

  .empty-text {
    font-size: 1rem;
  }

  .type-btn label,
  .quality-btn label {
    font-size: 0.95rem;
  }

  .type-buttons,
  .quality-buttons {
    flex-direction: column;
  }

  .type-btn,
  .quality-btn {
    min-width: 100%;
  }
}
</style>
